import { useState } from 'react';

export interface UploadProgramaFormData {
    pdfPrograma: File | null;
}

export default function useUploadProgramaForm() {
    const [formData, setFormData] = useState<UploadProgramaFormData>({ pdfPrograma: null });

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files?.length) {
            setFormData({ pdfPrograma: e.target.files[0] });
        }
    };

    const validateForm = () => {
        return !!formData.pdfPrograma;
    };

    return {
        formData,
        handleChange,
        validateForm
    };
}
